export default __webpack_public_path__ + "static/media/underground.c147d556.png";